import { FormControl, MenuItem, Select } from "@mui/material";
import { RS, US } from "country-flag-icons/react/3x2";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../app/api/hooks";
import i18n from "../../i18n";
import { DisplayLanguage } from "../../models/enums/displayLanguage";
import {
  selectDisplayLanguage,
  setDisplayLanguage,
} from "../../slices/displayLanguages/displayLanguageSlice";
import { useLanguageSwithcherStyles } from "./useLanguageSwitcherStyles";

export default function LanguageSwitcher() {
  const dispatch = useAppDispatch();
  const currentLanguage = useAppSelector(selectDisplayLanguage);
  const { t } = useTranslation();

  const { classes } = useLanguageSwithcherStyles();

  const onChangeLanguage = (value: string | null) => {
    const newLanguage = value as DisplayLanguage;

    if (!newLanguage) {
      return;
    }

    i18n.changeLanguage(
      newLanguage === DisplayLanguage.English
        ? "en-US"
        : newLanguage === DisplayLanguage.SerbianLatin
        ? "rs"
        : "rsCyrl"
    );

    dispatch(setDisplayLanguage(newLanguage));
  };

  return (
    <FormControl
      sx={{
        flexDirection: "row",
        alignItems: "center",
        width: 160,
        border: "none",
      }}
      fullWidth
    >
      <Select
        value={currentLanguage}
        onChange={(e) => onChangeLanguage(e.target.value)}
        className={classes.select}
        size="small"
        fullWidth
        sx={{ overflow: "hidden", fontSize: "0.8rem" }}
      >
        <MenuItem value={DisplayLanguage.English} sx={{ fontSize: "0.8rem" }}>
          <US className={classes.countryIcon} />
          {t("myProfile.englishLagnuage")}
        </MenuItem>

        <MenuItem
          value={DisplayLanguage.SerbianCyrillic}
          sx={{ fontSize: "0.8rem" }}
        >
          <RS className={classes.countryIcon} />
          {t("myProfile.serbianCyrlLanguage")}
        </MenuItem>

        <MenuItem
          value={DisplayLanguage.SerbianLatin}
          sx={{ fontSize: "0.8rem" }}
        >
          <RS className={classes.countryIcon} />
          {t("myProfile.serbianLatinLanguage")}
        </MenuItem>
      </Select>
    </FormControl>
  );
}
